var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "material-card",
    _vm._b(
      {
        staticClass: "v-card--material-chart",
        scopedSlots: _vm._u(
          [
            {
              key: "header",
              fn: function () {
                return [
                  _c("chartist", {
                    staticStyle: { "max-height": "150px" },
                    attrs: {
                      data: _vm.data,
                      "event-handlers": _vm.eventHandlers,
                      options: _vm.options,
                      ratio: _vm.ratio,
                      "responsive-options": _vm.responsiveOptions,
                      type: _vm.type,
                    },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "actions",
              fn: function () {
                return [_vm._t("actions")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      },
      "material-card",
      { ..._vm.$attrs },
      false
    ),
    [_vm._v(" "), _vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }